var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCodnew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 298,
    height: 189,
    viewBox: "0 0 298 189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6680b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b2334",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38757",
    "data-name": "Path 38757",
    d: "M897.751,160.38H954.89a4.461,4.461,0,0,1,4.461,4.461v41.606a4.461,4.461,0,0,1-4.461,4.461H899.982a8.922,8.922,0,0,1-8.922-8.922V167.071a6.691,6.691,0,0,1,6.691-6.691Z",
    transform: "translate(-891.06 -160.38)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20832",
    "data-name": "Group 20832",
    transform: "translate(-11251 -2850)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19367",
    "data-name": "Rectangle 19367",
    width: 298,
    height: 189,
    transform: "translate(11251 2850)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38664",
    "data-name": "Path 38664",
    d: "M442.75,650.232a.921.921,0,0,1,.584-.453,9.07,9.07,0,0,0,2.546-1.12,6.886,6.886,0,0,0,2.59-3.317c.137-.37.252-.749.381-1.122a.681.681,0,0,1,.65-.541.692.692,0,0,1,.666.548,11.131,11.131,0,0,0,.864,2.156,6.929,6.929,0,0,0,3.916,3.153c.287.1.577.188.862.289a.66.66,0,0,1,.479.629.639.639,0,0,1-.453.627c-.3.112-.6.2-.9.307a6.869,6.869,0,0,0-4.475,4.434c-.108.306-.2.616-.311.922a.659.659,0,0,1-1.273,0,12.663,12.663,0,0,0-.827-2.1,6.877,6.877,0,0,0-3.88-3.225c-.267-.092-.532-.19-.8-.266a.942.942,0,0,1-.612-.45Z",
    transform: "translate(10920.262 2214.479)",
    fill: "#eef1ff",
    opacity: 0.391
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38665",
    "data-name": "Path 38665",
    d: "M442.75,650.232a.921.921,0,0,1,.584-.453,9.07,9.07,0,0,0,2.546-1.12,6.886,6.886,0,0,0,2.59-3.317c.137-.37.252-.749.381-1.122a.681.681,0,0,1,.65-.541.692.692,0,0,1,.666.548,11.131,11.131,0,0,0,.864,2.156,6.929,6.929,0,0,0,3.916,3.153c.287.1.577.188.862.289a.66.66,0,0,1,.479.629.639.639,0,0,1-.453.627c-.3.112-.6.2-.9.307a6.869,6.869,0,0,0-4.475,4.434c-.108.306-.2.616-.311.922a.659.659,0,0,1-1.273,0,12.663,12.663,0,0,0-.827-2.1,6.877,6.877,0,0,0-3.88-3.225c-.267-.092-.532-.19-.8-.266a.942.942,0,0,1-.612-.45Z",
    transform: "translate(10984.86 2253.216)",
    fill: "#eef1ff",
    opacity: 0.286
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1446",
    "data-name": "Ellipse 1446",
    cx: 145.5,
    cy: 1,
    rx: 145.5,
    ry: 1,
    transform: "translate(11254 2981)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Cash_on_Delivery_Available",
    "data-name": "Cash on Delivery Available",
    transform: "translate(11308 3015)",
    fill: "#364668",
    fontSize: 15,
    fontFamily: "Ubuntu-Medium, Ubuntu",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Cash on Delivery Available")), /*#__PURE__*/React.createElement("path", {
    id: "Path_38656",
    "data-name": "Path 38656",
    d: "M442.75,650.232a.921.921,0,0,1,.584-.453,9.07,9.07,0,0,0,2.546-1.12,6.886,6.886,0,0,0,2.59-3.317c.137-.37.252-.749.381-1.122a.681.681,0,0,1,.65-.541.692.692,0,0,1,.666.548,11.131,11.131,0,0,0,.864,2.156,6.929,6.929,0,0,0,3.916,3.153c.287.1.577.188.862.289a.66.66,0,0,1,.479.629.639.639,0,0,1-.453.627c-.3.112-.6.2-.9.307a6.869,6.869,0,0,0-4.475,4.434c-.108.306-.2.616-.311.922a.659.659,0,0,1-1.273,0,12.663,12.663,0,0,0-.827-2.1,6.877,6.877,0,0,0-3.88-3.225c-.267-.092-.532-.19-.8-.266a.942.942,0,0,1-.612-.45Z",
    transform: "translate(10894.643 2232.049)",
    fill: "#eef1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38660",
    "data-name": "Path 38660",
    d: "M442.75,650.232a.921.921,0,0,1,.584-.453,9.07,9.07,0,0,0,2.546-1.12,6.886,6.886,0,0,0,2.59-3.317c.137-.37.252-.749.381-1.122a.681.681,0,0,1,.65-.541.692.692,0,0,1,.666.548,11.131,11.131,0,0,0,.864,2.156,6.929,6.929,0,0,0,3.916,3.153c.287.1.577.188.862.289a.66.66,0,0,1,.479.629.639.639,0,0,1-.453.627c-.3.112-.6.2-.9.307a6.869,6.869,0,0,0-4.475,4.434c-.108.306-.2.616-.311.922a.659.659,0,0,1-1.273,0,12.663,12.663,0,0,0-.827-2.1,6.877,6.877,0,0,0-3.88-3.225c-.267-.092-.532-.19-.8-.266a.942.942,0,0,1-.612-.45Z",
    transform: "translate(11066.004 2295.739)",
    fill: "#eef1ff",
    opacity: 0.286
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38663",
    "data-name": "Path 38663",
    d: "M442.75,650.232a.921.921,0,0,1,.584-.453,9.07,9.07,0,0,0,2.546-1.12,6.886,6.886,0,0,0,2.59-3.317c.137-.37.252-.749.381-1.122a.681.681,0,0,1,.65-.541.692.692,0,0,1,.666.548,11.131,11.131,0,0,0,.864,2.156,6.929,6.929,0,0,0,3.916,3.153c.287.1.577.188.862.289a.66.66,0,0,1,.479.629.639.639,0,0,1-.453.627c-.3.112-.6.2-.9.307a6.869,6.869,0,0,0-4.475,4.434c-.108.306-.2.616-.311.922a.659.659,0,0,1-1.273,0,12.663,12.663,0,0,0-.827-2.1,6.877,6.877,0,0,0-3.88-3.225c-.267-.092-.532-.19-.8-.266a.942.942,0,0,1-.612-.45Z",
    transform: "translate(11066.004 2268.516)",
    fill: "#eef1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38657",
    "data-name": "Path 38657",
    d: "M640.522,499.75a.962.962,0,0,1,.446.566,6.832,6.832,0,0,0,4.155,4.154c.294.113.542.253.578.6a.632.632,0,0,1-.47.713,7.431,7.431,0,0,0-1.641.823A6.875,6.875,0,0,0,641,509.892c-.033.085-.062.173-.1.257a.658.658,0,0,1-1.227-.017,9.35,9.35,0,0,0-.453-1.047,6.842,6.842,0,0,0-3.787-3.269.717.717,0,0,1-.552-.576.654.654,0,0,1,.5-.736,7.05,7.05,0,0,0,1.878-1,6.8,6.8,0,0,0,2.34-3.148,1.023,1.023,0,0,1,.459-.605Z",
    transform: "translate(10667.641 2389.533)",
    fill: "#eef1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38662",
    "data-name": "Path 38662",
    d: "M640.522,499.75a.962.962,0,0,1,.446.566,6.832,6.832,0,0,0,4.155,4.154c.294.113.542.253.578.6a.632.632,0,0,1-.47.713,7.431,7.431,0,0,0-1.641.823A6.875,6.875,0,0,0,641,509.892c-.033.085-.062.173-.1.257a.658.658,0,0,1-1.227-.017,9.35,9.35,0,0,0-.453-1.047,6.842,6.842,0,0,0-3.787-3.269.717.717,0,0,1-.552-.576.654.654,0,0,1,.5-.736,7.05,7.05,0,0,0,1.878-1,6.8,6.8,0,0,0,2.34-3.148,1.023,1.023,0,0,1,.459-.605Z",
    transform: "translate(10712.021 2439.668)",
    fill: "#eef1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38658",
    "data-name": "Path 38658",
    d: "M446.345,499.75a.83.83,0,0,1,.453.5,3.64,3.64,0,0,0,2.16,2.189c.057.023.119.043.177.07a.635.635,0,0,1,.388.607.612.612,0,0,1-.388.583,5.74,5.74,0,0,0-.91.446,3.664,3.664,0,0,0-1.4,1.735c-.016.04-.031.079-.045.119a.66.66,0,0,1-1.274,0,3.89,3.89,0,0,0-.514-.968,3.6,3.6,0,0,0-1.683-1.263.838.838,0,0,1-.521-.46v-.424a.914.914,0,0,1,.535-.445,3.58,3.58,0,0,0,2.153-2.154.924.924,0,0,1,.445-.535Z",
    transform: "translate(10832.445 2425.003)",
    fill: "#dadafd",
    opacity: 0.319
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38672",
    "data-name": "Path 38672",
    d: "M446.345,499.75a.83.83,0,0,1,.453.5,3.64,3.64,0,0,0,2.16,2.189c.057.023.119.043.177.07a.635.635,0,0,1,.388.607.612.612,0,0,1-.388.583,5.74,5.74,0,0,0-.91.446,3.664,3.664,0,0,0-1.4,1.735c-.016.04-.031.079-.045.119a.66.66,0,0,1-1.274,0,3.89,3.89,0,0,0-.514-.968,3.6,3.6,0,0,0-1.683-1.263.838.838,0,0,1-.521-.46v-.424a.914.914,0,0,1,.535-.445,3.58,3.58,0,0,0,2.153-2.154.924.924,0,0,1,.445-.535Z",
    transform: "translate(11032.188 2365.185)",
    fill: "#eef1ff",
    opacity: 0.286
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38670",
    "data-name": "Path 38670",
    d: "M446.345,499.75a.83.83,0,0,1,.453.5,3.64,3.64,0,0,0,2.16,2.189c.057.023.119.043.177.07a.635.635,0,0,1,.388.607.612.612,0,0,1-.388.583,5.74,5.74,0,0,0-.91.446,3.664,3.664,0,0,0-1.4,1.735c-.016.04-.031.079-.045.119a.66.66,0,0,1-1.274,0,3.89,3.89,0,0,0-.514-.968,3.6,3.6,0,0,0-1.683-1.263.838.838,0,0,1-.521-.46v-.424a.914.914,0,0,1,.535-.445,3.58,3.58,0,0,0,2.153-2.154.924.924,0,0,1,.445-.535Z",
    transform: "translate(10967.836 2374.244)",
    fill: "#eef1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38666",
    "data-name": "Path 38666",
    d: "M446.345,499.75a.83.83,0,0,1,.453.5,3.64,3.64,0,0,0,2.16,2.189c.057.023.119.043.177.07a.635.635,0,0,1,.388.607.612.612,0,0,1-.388.583,5.74,5.74,0,0,0-.91.446,3.664,3.664,0,0,0-1.4,1.735c-.016.04-.031.079-.045.119a.66.66,0,0,1-1.274,0,3.89,3.89,0,0,0-.514-.968,3.6,3.6,0,0,0-1.683-1.263.838.838,0,0,1-.521-.46v-.424a.914.914,0,0,1,.535-.445,3.58,3.58,0,0,0,2.153-2.154.924.924,0,0,1,.445-.535Z",
    transform: "translate(10848.231 2458.642)",
    fill: "#eef1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38673",
    "data-name": "Path 38673",
    d: "M446.345,499.75a.83.83,0,0,1,.453.5,3.64,3.64,0,0,0,2.16,2.189c.057.023.119.043.177.07a.635.635,0,0,1,.388.607.612.612,0,0,1-.388.583,5.74,5.74,0,0,0-.91.446,3.664,3.664,0,0,0-1.4,1.735c-.016.04-.031.079-.045.119a.66.66,0,0,1-1.274,0,3.89,3.89,0,0,0-.514-.968,3.6,3.6,0,0,0-1.683-1.263.838.838,0,0,1-.521-.46v-.424a.914.914,0,0,1,.535-.445,3.58,3.58,0,0,0,2.153-2.154.924.924,0,0,1,.445-.535Z",
    transform: "translate(10868.853 2421.634)",
    fill: "#eef1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38667",
    "data-name": "Path 38667",
    d: "M446.345,499.75a.83.83,0,0,1,.453.5,3.64,3.64,0,0,0,2.16,2.189c.057.023.119.043.177.07a.635.635,0,0,1,.388.607.612.612,0,0,1-.388.583,5.74,5.74,0,0,0-.91.446,3.664,3.664,0,0,0-1.4,1.735c-.016.04-.031.079-.045.119a.66.66,0,0,1-1.274,0,3.89,3.89,0,0,0-.514-.968,3.6,3.6,0,0,0-1.683-1.263.838.838,0,0,1-.521-.46v-.424a.914.914,0,0,1,.535-.445,3.58,3.58,0,0,0,2.153-2.154.924.924,0,0,1,.445-.535Z",
    transform: "translate(10996.379 2358.408)",
    fill: "#eef1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38668",
    "data-name": "Path 38668",
    d: "M446.345,499.75a.83.83,0,0,1,.453.5,3.64,3.64,0,0,0,2.16,2.189c.057.023.119.043.177.07a.635.635,0,0,1,.388.607.612.612,0,0,1-.388.583,5.74,5.74,0,0,0-.91.446,3.664,3.664,0,0,0-1.4,1.735c-.016.04-.031.079-.045.119a.66.66,0,0,1-1.274,0,3.89,3.89,0,0,0-.514-.968,3.6,3.6,0,0,0-1.683-1.263.838.838,0,0,1-.521-.46v-.424a.914.914,0,0,1,.535-.445,3.58,3.58,0,0,0,2.153-2.154.924.924,0,0,1,.445-.535Z",
    transform: "translate(11038.92 2418.265)",
    fill: "#eef1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38669",
    "data-name": "Path 38669",
    d: "M446.345,499.75a.83.83,0,0,1,.453.5,3.64,3.64,0,0,0,2.16,2.189c.057.023.119.043.177.07a.635.635,0,0,1,.388.607.612.612,0,0,1-.388.583,5.74,5.74,0,0,0-.91.446,3.664,3.664,0,0,0-1.4,1.735c-.016.04-.031.079-.045.119a.66.66,0,0,1-1.274,0,3.89,3.89,0,0,0-.514-.968,3.6,3.6,0,0,0-1.683-1.263.838.838,0,0,1-.521-.46v-.424a.914.914,0,0,1,.535-.445,3.58,3.58,0,0,0,2.153-2.154.924.924,0,0,1,.445-.535Z",
    transform: "translate(11049.571 2453.223)",
    fill: "#eef1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38661",
    "data-name": "Path 38661",
    d: "M446.345,499.75a.83.83,0,0,1,.453.5,3.64,3.64,0,0,0,2.16,2.189c.057.023.119.043.177.07a.635.635,0,0,1,.388.607.612.612,0,0,1-.388.583,5.74,5.74,0,0,0-.91.446,3.664,3.664,0,0,0-1.4,1.735c-.016.04-.031.079-.045.119a.66.66,0,0,1-1.274,0,3.89,3.89,0,0,0-.514-.968,3.6,3.6,0,0,0-1.683-1.263.838.838,0,0,1-.521-.46v-.424a.914.914,0,0,1,.535-.445,3.58,3.58,0,0,0,2.153-2.154.924.924,0,0,1,.445-.535Z",
    transform: "translate(10930.394 2388.2)",
    fill: "#eef1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38659",
    "data-name": "Path 38659",
    d: "M713.684,767.336a.634.634,0,0,1-.48.644,3.7,3.7,0,0,0-1.886,1.5,4.3,4.3,0,0,0-.377.779.634.634,0,0,1-.64.456.64.64,0,0,1-.618-.461,3.664,3.664,0,0,0-2.263-2.275.658.658,0,0,1,0-1.271,3.634,3.634,0,0,0,2.246-2.237.685.685,0,0,1,.636-.5.676.676,0,0,1,.655.509,3.667,3.667,0,0,0,2.249,2.236A.642.642,0,0,1,713.684,767.336Z",
    transform: "translate(10581.837 2187.677)",
    fill: "#eef1ff",
    opacity: 0.286
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38671",
    "data-name": "Path 38671",
    d: "M713.684,767.336a.634.634,0,0,1-.48.644,3.7,3.7,0,0,0-1.886,1.5,4.3,4.3,0,0,0-.377.779.634.634,0,0,1-.64.456.64.64,0,0,1-.618-.461,3.664,3.664,0,0,0-2.263-2.275.658.658,0,0,1,0-1.271,3.634,3.634,0,0,0,2.246-2.237.685.685,0,0,1,.636-.5.676.676,0,0,1,.655.509,3.667,3.667,0,0,0,2.249,2.236A.642.642,0,0,1,713.684,767.336Z",
    transform: "translate(10774.776 2121.942)",
    fill: "#dadafd",
    opacity: 0.157
  }), /*#__PURE__*/React.createElement("g", {
    id: "COD",
    transform: "translate(11328 2874.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38734",
    "data-name": "Path 38734",
    d: "M885.917,140.185a5.7,5.7,0,0,1-3.569-1.7L835.71,95.835c-.37-.339-.615-.571-.825-.767-.3-.285-.535-.509-.928-.848-1.2-1.039-2.338-2.1-3.693-3.368-1.6-1.5-2.231-3.569-1.338-4.514,6.013-6.611,12.12-13.284,18.142-19.837a1.739,1.739,0,0,1,1.294-.446,5.059,5.059,0,0,1,2.989,1.2c.334.263.656.535.955.812L903.309,114.7a10.982,10.982,0,0,1,1.508,1.593c.981,1.374,1.218,2.913.562,3.662-.919,1.053-1.9,2.123-3,3.274-.277.294-.54.584-.892.977l-.036.04c-3.716,4.1-7.512,8.244-11.183,12.254l-2.77,3.029a2.047,2.047,0,0,1-1.584.656Z",
    transform: "translate(-784.571 -64.278)",
    fill: "#3bb44a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38735",
    "data-name": "Path 38735",
    d: "M846.174,65.544a3.333,3.333,0,0,1,1.883.816c.3.236.589.482.856.727q25.516,23.326,51.019,46.66a9.539,9.539,0,0,1,1.262,1.311,2.712,2.712,0,0,1,.6,1.53c-.892,1.008-1.824,2.034-2.877,3.123-.3.317-.589.629-.946,1.026h-.022c-3.751,4.131-7.583,8.324-11.295,12.374l-2.677,2.9c-.031.036-.067.076-.254.076a4,4,0,0,1-2.364-1.227l-24.428-22.34L834.723,92.21c-.361-.33-.6-.558-.8-.749-.3-.285-.567-.535-.99-.892-1.178-1.017-2.3-2.061-3.636-3.319a3.182,3.182,0,0,1-1.178-2.1c5.973-6.562,12.018-13.168,17.959-19.628h.1m0-3.569a3.457,3.457,0,0,0-2.609,1.048q-9.1,9.9-18.147,19.837c-1.566,1.722-.892,4.8,1.45,7.021,1.236,1.155,2.471,2.315,3.751,3.417.629.54.821.767,1.713,1.584l46.638,42.65a7.346,7.346,0,0,0,4.773,2.164,3.81,3.81,0,0,0,2.891-1.236q6.986-7.632,13.962-15.287c.366-.4.625-.691.892-.986q1.561-1.633,3.047-3.328c1.245-1.423,1.039-3.787-.446-5.875a12.21,12.21,0,0,0-1.753-1.874L851.309,64.46c-.339-.312-.691-.611-1.053-.892a6.816,6.816,0,0,0-4.082-1.593Z",
    transform: "translate(-782.384 -62.01)",
    fill: "#588f5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38736",
    "data-name": "Path 38736",
    d: "M908.076,141.423a13.726,13.726,0,1,1-.593-19.182,13.726,13.726,0,0,1,.593,19.182Z",
    transform: "translate(-815.438 -93.281)",
    fill: "#2b9f37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38737",
    "data-name": "Path 38737",
    d: "M872.391,79.226a2.949,2.949,0,0,1-4.309.223,3.033,3.033,0,0,1-.152-4.381,3.123,3.123,0,0,1,4.345-.214A3.041,3.041,0,0,1,872.391,79.226Z",
    transform: "translate(-805.924 -68.724)",
    fill: "#2b9f37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38738",
    "data-name": "Path 38738",
    d: "M947.573,208.824a3.191,3.191,0,0,1,4.363-.161,3.033,3.033,0,0,1,.161,4.4,3,3,0,0,1-4.358.17A3.17,3.17,0,0,1,947.573,208.824Z",
    transform: "translate(-850.069 -142.839)",
    fill: "#2b9f37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38739",
    "data-name": "Path 38739",
    d: "M908.764,134.981c-1.071-.981-2.021-1.842-2.958-2.712a6.061,6.061,0,0,1-.638-.674,1.432,1.432,0,0,1,.036-1.882,1.468,1.468,0,0,1,1.847-.415,2.673,2.673,0,0,1,.687.513l3.042,2.779a2.07,2.07,0,0,0-.361-2.369c-.6-.567-1.218-1.1-1.807-1.664a1.542,1.542,0,0,1-.214-2.342,1.506,1.506,0,0,1,2.3.027q3.372,3.051,6.691,6.138a1.563,1.563,0,0,1,.232,2.3,1.618,1.618,0,0,1-2.36,0l-.343-.312c-.794-.732-.785-.723-1.294.2-.174.317-.214.544.12.781a4.557,4.557,0,0,1,.682.629,1.539,1.539,0,0,1,.094,2.106,1.378,1.378,0,0,1-2.061.205,2.087,2.087,0,0,0-2.587-.446,4.556,4.556,0,0,1-3.729-.339c-.138-.067-.277-.143-.415-.205h-.165l.388,5.224a1.561,1.561,0,0,1-.6,1.526,1.534,1.534,0,0,1-2.48-1.173c-.165-2.03-.29-4.059-.446-6.089q-.1-1.392-.192-2.784a1.678,1.678,0,0,1,.892-1.824,1.622,1.622,0,0,1,1.923.446c.629.593,1.271,1.169,1.914,1.744A2.458,2.458,0,0,0,908.764,134.981Z",
    transform: "translate(-825.395 -97.318)",
    fill: "#fdda41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38740",
    "data-name": "Path 38740",
    d: "M850.684,140.913a6.209,6.209,0,0,1-3.319-1.191L795.04,104.285c-.419-.281-.7-.477-.932-.642-.335-.236-.6-.424-1.039-.7-1.338-.852-2.619-1.735-4.14-2.8-1.784-1.254-2.712-3.207-2-4.273,4.983-7.4,10.055-14.881,15.064-22.255a2.029,2.029,0,0,1,1.686-.687,5.46,5.46,0,0,1,2.677.79c.366.21.723.446,1.066.665l57.241,38.765a10.643,10.643,0,0,1,1.722,1.338c1.173,1.213,1.633,2.7,1.093,3.542-.758,1.169-1.57,2.369-2.494,3.671-.232.33-.446.656-.749,1.1l-.027.045c-3.123,4.648-6.325,9.368-9.417,13.931l-2.177,3.216A2.173,2.173,0,0,1,850.684,140.913Z",
    transform: "translate(-761.401 -68.089)",
    fill: "#3bb44a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38741",
    "data-name": "Path 38741",
    d: "M801.491,72.491a3.734,3.734,0,0,1,1.784.549c.33.192.651.393.955.6L861.475,112.4a9.611,9.611,0,0,1,1.441,1.115,2.712,2.712,0,0,1,.816,1.427c-.732,1.124-1.512,2.275-2.391,3.52-.254.361-.491.709-.79,1.155h0c-3.123,4.635-6.308,9.341-9.368,13.9l-2.2,3.247c0,.027-.085.12-.446.12a4.309,4.309,0,0,1-2.32-.892l-27.693-18.682-24.7-16.724c-.406-.272-.674-.446-.892-.625-.339-.241-.638-.446-1.106-.749-1.316-.834-2.574-1.7-4.082-2.752a3.271,3.271,0,0,1-1.472-1.9c4.96-7.365,9.983-14.774,14.921-22.032a1.416,1.416,0,0,1,.3-.031m0-3.569a3.68,3.68,0,0,0-3.163,1.468Q790.753,81.5,783.259,92.654c-1.3,1.932-.205,4.88,2.453,6.731,1.387.968,2.779,1.932,4.207,2.837.7.446.923.642,1.923,1.338l52.321,35.428a7.864,7.864,0,0,0,4.318,1.5,3.93,3.93,0,0,0,3.4-1.691q5.8-8.574,11.6-17.152c.3-.446.522-.776.754-1.106q1.3-1.838,2.534-3.734c1.021-1.588.477-3.9-1.3-5.75a12.683,12.683,0,0,0-2.008-1.6L806.21,70.68c-.384-.254-.776-.5-1.173-.732a7.231,7.231,0,0,0-3.569-1.026Z",
    transform: "translate(-759.197 -65.866)",
    fill: "#588f5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38742",
    "data-name": "Path 38742",
    d: "M871.706,139.855a13.726,13.726,0,1,1-3.372-18.9,13.726,13.726,0,0,1,3.372,18.9Z",
    transform: "translate(-794.605 -93.279)",
    fill: "#2b9f37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38743",
    "data-name": "Path 38743",
    d: "M825.6,85.561a2.953,2.953,0,0,1-4.233.848,3.029,3.029,0,0,1-.807-4.309,3.123,3.123,0,0,1,4.265-.843A3.03,3.03,0,0,1,825.6,85.561Z",
    transform: "translate(-779.847 -72.424)",
    fill: "#2b9f37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38744",
    "data-name": "Path 38744",
    d: "M918.786,202.874a3.187,3.187,0,0,1,4.291-.794,3.1,3.1,0,0,1-3.488,5.13A3.164,3.164,0,0,1,918.786,202.874Z",
    transform: "translate(-834.28 -139.342)",
    fill: "#2b9f37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38745",
    "data-name": "Path 38745",
    d: "M870.618,134.766c-1.2-.812-2.262-1.526-3.319-2.253a6.03,6.03,0,0,1-.727-.549,1.436,1.436,0,0,1-.241-1.869,1.472,1.472,0,0,1,1.784-.678,2.8,2.8,0,0,1,.754.406l3.413,2.311a2.07,2.07,0,0,0-.7-2.293c-.669-.473-1.338-.892-2.03-1.387a1.546,1.546,0,0,1-.549-2.279,1.515,1.515,0,0,1,2.28-.308q3.783,2.529,7.53,5.1a1.551,1.551,0,0,1,.562,2.23,1.618,1.618,0,0,1-2.333.33l-.384-.259c-.892-.607-.892-.6-1.254.384-.125.335-.134.571.232.754a4.946,4.946,0,0,1,.767.522,1.544,1.544,0,0,1,.4,2.074,1.378,1.378,0,0,1-2.007.5,2.07,2.07,0,0,0-2.623-.054,4.553,4.553,0,0,1-3.743.205l-.446-.143h-.165c.379,1.708.763,3.408,1.142,5.112a1.566,1.566,0,0,1-.375,1.593,1.539,1.539,0,0,1-2.627-.8c-.446-1.985-.892-3.975-1.312-5.964-.2-.892-.393-1.816-.593-2.726a1.615,1.615,0,0,1,2.6-1.766c.709.5,1.427.968,2.146,1.45A2.476,2.476,0,0,0,870.618,134.766Z",
    transform: "translate(-804.209 -97.206)",
    fill: "#fdda41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38746",
    "data-name": "Path 38746",
    d: "M831.357,156.455a7.351,7.351,0,0,1-2.3-.406L769.1,136.06c-.477-.161-.8-.272-1.071-.37-.388-.138-.7-.245-1.191-.393-1.517-.446-2.984-.964-4.742-1.575-2.07-.723-3.475-2.36-3.073-3.569,2.8-8.476,5.665-17.049,8.5-25.5.263-.776,1.312-1.276,2.677-1.276a6.173,6.173,0,0,1,1.535.2c.41.107.816.223,1.2.352l65.574,21.858a10.8,10.8,0,0,1,2.025.843c1.454.852,2.3,2.163,2,3.123-.41,1.338-.892,2.717-1.405,4.211-.138.388-.263.772-.446,1.3-1.74,5.277-3.524,10.63-5.255,15.809l-1.28,3.841C833.708,156.294,832.049,156.455,831.357,156.455Z",
    transform: "translate(-746.039 -84.956)",
    fill: "#3bb44a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38747",
    "data-name": "Path 38747",
    d: "M768.008,102.929h0a4.46,4.46,0,0,1,1.088.143q.562.147,1.084.321l65.574,21.858a9.275,9.275,0,0,1,1.686.687,2.677,2.677,0,0,1,1.169,1.151c-.4,1.28-.839,2.6-1.338,4.015-.147.415-.281.816-.446,1.338v.031c-1.744,5.3-3.547,10.706-5.282,15.9l-1.249,3.738c-.058.183-.553.326-1.124.326a5.636,5.636,0,0,1-1.74-.312l-29.977-10-29.968-9.988c-.446-.152-.772-.263-1.039-.357-.392-.138-.732-.259-1.267-.419-1.494-.446-2.94-.95-4.675-1.552a3.326,3.326,0,0,1-1.932-1.436c2.792-8.427,5.625-16.92,8.422-25.244a2.23,2.23,0,0,1,1.031-.2m0-3.569c-2.1,0-3.836.892-4.367,2.494q-4.282,12.74-8.507,25.507c-.732,2.23,1.124,4.755,4.18,5.8,1.6.558,3.2,1.115,4.818,1.6.794.236,1.062.366,2.208.745L826.311,155.5a9.038,9.038,0,0,0,2.868.5c2.2,0,3.917-.986,4.51-2.766q3.279-9.814,6.535-19.628c.17-.517.294-.892.446-1.271.5-1.419.986-2.842,1.432-4.282.553-1.784-.593-3.881-2.806-5.179a12.115,12.115,0,0,0-2.364-.995q-32.792-10.942-65.574-21.858c-.446-.147-.892-.277-1.338-.393a8.172,8.172,0,0,0-1.976-.254Z",
    transform: "translate(-743.844 -82.729)",
    fill: "#588f5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38748",
    "data-name": "Path 38748",
    d: "M848.588,150.261a13.726,13.726,0,1,1-8.346-17.277,13.726,13.726,0,0,1,8.346,17.277Z",
    transform: "translate(-780.877 -100.901)",
    fill: "#2b9f37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38749",
    "data-name": "Path 38749",
    d: "M786.477,114.468a2.949,2.949,0,0,1-3.845,1.958,3.029,3.029,0,0,1-1.941-3.93,3.123,3.123,0,0,1,3.881-1.963A3.024,3.024,0,0,1,786.477,114.468Z",
    transform: "translate(-757.977 -88.84)",
    fill: "#2b9f37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38750",
    "data-name": "Path 38750",
    d: "M907.818,202.255a3.2,3.2,0,0,1,3.921-1.927,3.1,3.1,0,0,1-1.981,5.884A3.2,3.2,0,0,1,907.818,202.255Z",
    transform: "translate(-828.415 -138.567)",
    fill: "#2b9f37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38751",
    "data-name": "Path 38751",
    d: "M845.078,148.713c-1.378-.446-2.592-.856-3.805-1.271a5.465,5.465,0,0,1-.852-.357,1.427,1.427,0,0,1-.736-1.731,1.459,1.459,0,0,1,1.517-1.129,2.82,2.82,0,0,1,.839.183l3.908,1.3a2.065,2.065,0,0,0-1.294-2.016c-.772-.272-1.557-.509-2.328-.785a1.54,1.54,0,0,1-1.146-2.048,1.488,1.488,0,0,1,2.11-.892q4.323,1.419,8.627,2.877a1.562,1.562,0,0,1,1.146,2,1.6,1.6,0,0,1-2.159.946c-.147-.045-.294-.1-.446-.147-1.022-.339-1.008-.339-1.1.709-.031.357,0,.584.446.665a4.727,4.727,0,0,1,.892.294,1.543,1.543,0,0,1,.946,1.887,1.378,1.378,0,0,1-1.784,1.026,2.07,2.07,0,0,0-2.543.66,4.591,4.591,0,0,1-3.546,1.209c-.156,0-.308-.022-.446-.022a.629.629,0,0,0-.152.058l2.48,4.617a1.57,1.57,0,0,1,.071,1.637,1.539,1.539,0,0,1-2.743-.062c-.977-1.784-1.918-3.591-2.877-5.389q-.651-1.231-1.307-2.462a1.631,1.631,0,0,1,.089-2.034,1.606,1.606,0,0,1,1.94-.37c.812.285,1.637.549,2.458.816A2.44,2.44,0,0,0,845.078,148.713Z",
    transform: "translate(-790.094 -105.148)",
    fill: "#fdda41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38752",
    "data-name": "Path 38752",
    d: "M167.751,98.36H224.89a4.461,4.461,0,0,1,4.461,4.461v41.606a4.461,4.461,0,0,1-4.461,4.461H169.982a8.922,8.922,0,0,1-8.922-8.922V105.051A6.691,6.691,0,0,1,167.751,98.36Z",
    transform: "translate(-89.214 -54.514)",
    fill: "#aa5d24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38753",
    "data-name": "Path 38753",
    d: "M8.922,0H67.385a4.461,4.461,0,0,1,4.461,4.461V46.067a4.461,4.461,0,0,1-4.461,4.461H6.691A6.691,6.691,0,0,1,0,43.837V8.922A8.922,8.922,0,0,1,8.922,0Z",
    transform: "translate(71.846 94.374) rotate(180)",
    fill: "#aa5d24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38754",
    "data-name": "Path 38754",
    d: "M8.922,0h3.123V50.528H6.691A6.691,6.691,0,0,1,0,43.837V8.922A8.922,8.922,0,0,1,8.922,0Z",
    transform: "translate(71.842 94.374) rotate(180)",
    fill: "#7c3d1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38755",
    "data-name": "Path 38755",
    d: "M167.751,98.36H173.1v50.532h-3.123a8.922,8.922,0,0,1-8.922-8.922V105.051A6.691,6.691,0,0,1,167.751,98.36Z",
    transform: "translate(-89.214 -54.514)",
    fill: "#7c3d1e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20820",
    "data-name": "Group 20820",
    transform: "translate(71.846 43.851)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38756",
    "data-name": "Path 38756",
    d: "M277.56,142.17h11.348a3.948,3.948,0,0,1,3.948,3.939v10.068a3.948,3.948,0,0,1-3.948,3.948H277.56a8.98,8.98,0,0,1-8.98-8.98h0A8.98,8.98,0,0,1,277.56,142.17Z",
    transform: "translate(-220.617 -122.632)",
    fill: "#7c3d1e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_38758",
    "data-name": "Path 38758",
    d: "M277.56,134.65h11.348a3.948,3.948,0,0,1,3.948,3.948v10.068a3.948,3.948,0,0,1-3.948,3.948H277.56a8.98,8.98,0,0,1-8.98-8.98h0a8.98,8.98,0,0,1,8.98-8.98Z",
    transform: "translate(-148.771 -74.615)",
    fill: "#fda732"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1447",
    "data-name": "Ellipse 1447",
    cx: 4.34,
    cy: 4.34,
    r: 4.34,
    transform: "translate(123.561 64.576)",
    fill: "#fecb33"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1448",
    "data-name": "Ellipse 1448",
    cx: 68.982,
    cy: 3.256,
    rx: 68.982,
    ry: 3.256,
    transform: "translate(2.172 96.944)",
    fill: "#7c3d1e",
    opacity: 0.23
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodnew);
export default __webpack_public_path__ + "static/media/codnew.500cd516a7d7414037801a04dbad4c75.svg";
export { ForwardRef as ReactComponent };